// extracted by mini-css-extract-plugin
module.exports = {"btn-del":"IntegrationAssetForm_btn-del__1CZSd","schemaWrapper":"IntegrationAssetForm_schemaWrapper__3OO1W","table-wrapper":"IntegrationAssetForm_table-wrapper__3pRFH"};